import { useQuery } from '@tanstack/react-query';

import { Zone } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/zone/:zoneId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    zoneId: string;
}
const queryFn = ({ parkingId, zoneId }: DTO): Promise<Zone> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, zoneId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetZone };
